"use strict";
module.exports = {
    main: 'line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;',
    error: 'line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;',
    key: 'color:#f92672;',
    string: 'color:#fd971f;',
    value: 'color:#a6e22e;',
    boolean: 'color:#ac81fe;',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-json-pretty/dist/monikai.js
// module id = 1291
// module chunks = 0